import React from "react";

const About = () =>{
  return(
    <div>
        <h2>À propos</h2>
    </div>
  )

}

export default About;